$(document).ready(function () {

	$('.akt--link').on('click', function() {
		$('.akt--link').removeClass('active');
		$(this).addClass('active');

		var id = $(this).data('id');

		$('.tab-pane').removeClass('active').addClass('fade');
		$('#'+id).removeClass('fade').addClass('active');


	})

});